/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { B400, G300, P300, R400, Y300 } from '@atlaskit/theme/colors';
import { typesMapping } from '../../constants';
var iconColor = {
  connectivity: "_1b3i1c86",
  confirmation: "_1b3icdx1",
  info: "_1b3ige5s",
  warning: "_1b3i1n6p",
  error: "_1b3i1378"
};
var iconWrapperStyles = null;
var iconColorStyles = null;

/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */
var SelectedIcon = function SelectedIcon(_ref) {
  var appearance = _ref.appearance,
    isOpen = _ref.isOpen,
    label = _ref.label;
  var _typesMapping$appeara = typesMapping[appearance],
    Icon = _typesMapping$appeara.icon,
    defaultLabel = _typesMapping$appeara.defaultLabel;
  return /*#__PURE__*/React.createElement("span", {
    "data-ds--inline-message--icon": true,
    className: ax(["_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v", isOpen && "_syaz1kum", iconColor[appearance]])
  }, /*#__PURE__*/React.createElement(Icon, {
    testId: "inline-message-icon",
    label: label || defaultLabel,
    color: "currentColor",
    LEGACY_size: "medium",
    spacing: "spacious"
  }));
};
export default SelectedIcon;